<div class="main-layout">
  <span id="top"></span>
  <app-header *ngIf="shouldShowHeader()"></app-header>
  <div class="main">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
